export const UserManagementTableHeader = [
	{
		width: 120,
		title: 'Plant',
		field: 'plant_name',
		enableSearch: true,
		enableFilter: true,
	},
	{
		width: 220,
		title: 'User Role',
		field: 'user_role_name',
		enableSearch: true,
		enableFilter: true,
	},
	{
		width: 220,
		title: 'Commodity Type Name',
		field: 'commodity_type_name',
		enableSearch: true,
		enableFilter: true,
	},
	{
		width: 200,
		title: 'Full Name',
		field: 'full_name',
		enableSearch: true,
		enableFilter: true,
	},
	{
		width: 200,
		title: 'Domain Name',
		field: 'domain_name',
		enableSearch: true,
		enableFilter: true,
	},
	{
		width: 220,
		title: 'Email ID',
		field: 'email_id',
		enableSearch: true,
		enableFilter: true,
	},
	{
		width: 150,
		title: 'Vendor Code',
		field: 'vendor_code',
		enableSearch: true,
		enableFilter: true,
	},
	{
		width: 150,
		title: 'Buyer Code',
		field: 'buyer_code',
		enableSearch: true,
		enableFilter: true,
	},
	{
		width: 150,
		title: 'Admin Access',
		field: 'is_admin_access_modified',
		enableSearch: true,
		enableFilter: true,
	},
	{
		width: 130,
		title: 'Mobile No.',
		field: 'mobile_no',
		enableSearch: true,
		enableFilter: true,
	},
	{
		width: 160,
		title: 'Updated At',
		field: 'updated_at',  
		enableSearch: true,
		enableFilter: true,
	},
	{
		width: 160,
		title: 'Updated By',
		field: 'updated_by',
		enableSearch: true,
		enableFilter: true,
	},
	{
		width: 160,
		title: 'Created At',
		field: 'created_at',
		enableSearch: true,
		enableFilter: true,
	},
	{
		width: 160,
		title: 'Created By',
		field: 'created_by',
		enableSearch: true,
		enableFilter: true,
	},
];
